import { cn } from "@/lib/utils";

interface NumberPillProps {
  number: number;
  variant?: "main" | "bonus" | "matched" | "unmatched";
  size?: "sm" | "md" | "lg";
}

export function NumberPill({ number, variant = "main", size = "md" }: NumberPillProps) {
  return (
    <span
      className={cn(
        "lottery-ball inline-flex items-center justify-center rounded-full font-display font-bold relative select-none",
        {
          "lottery-ball-main": variant === "main",
          "lottery-ball-bonus": variant === "bonus",
          "lottery-ball-matched": variant === "matched",
          "lottery-ball-unmatched": variant === "unmatched",
          "h-8 w-8 text-xs": size === "sm",
          "h-10 w-10 text-sm": size === "md",
          "h-12 w-12 text-base": size === "lg",
        }
      )}
    >
      <span className="relative z-10">{number}</span>
    </span>
  );
}

interface NumberRowProps {
  numbers: number[];
  bonusNumbers?: number[];
  multiplier?: number | null;
  size?: "sm" | "md" | "lg";
  matchedNumbers?: number[];
  matchedBonus?: number[];
}

interface NumberRowProps2 extends NumberRowProps {
  nowrap?: boolean;
  align?: "left" | "center";
}

export function NumberRow({
  numbers,
  bonusNumbers = [],
  multiplier,
  size = "md",
  matchedNumbers,
  matchedBonus,
  nowrap = false,
  align = "center",
}: NumberRowProps2) {
  return (
    <div className={cn("flex items-center gap-1.5", align === "left" ? "justify-start" : "justify-center", nowrap ? "flex-nowrap" : "flex-wrap")}>
      {numbers.map((n, i) => (
        <NumberPill
          key={`main-${i}`}
          number={n}
          size={size}
          variant={
            matchedNumbers
              ? matchedNumbers.includes(n)
                ? "matched"
                : "unmatched"
              : "main"
          }
        />
      ))}
      {bonusNumbers.length > 0 && (
        <>
          <span className="mx-1 text-muted-foreground font-bold">+</span>
          {bonusNumbers.map((n, i) => (
            <NumberPill
              key={`bonus-${i}`}
              number={n}
              size={size}
              variant={
                matchedBonus
                  ? matchedBonus.includes(n)
                    ? "matched"
                    : "unmatched"
                  : "bonus"
              }
            />
          ))}
        </>
      )}
      {multiplier && (
        <span className="ml-2 rounded-md bg-accent px-2 py-1 text-xs font-bold text-accent-foreground">
          x{multiplier}
        </span>
      )}
    </div>
  );
}
